import React from 'react';
import PropTypes from 'prop-types';
import { StyledLabel } from 'components/grid/table/components/label/style';

const Label = ({ children, label, invalid, fontSize, style }: any) => {
  const labelProps = {
    fontSize,
    ...(invalid ? { invalid } : {}),
    ...(style ? { style } : {}),
  };
  const content = children ? children : label;

  return (
    Boolean(content) && <StyledLabel {...labelProps}>{content}</StyledLabel>
  );
};

Label.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
};

Label.defaultProps = {
  children: null,
  label: '',
};

export default Label;
